import { createFileRoute } from '@tanstack/react-router';
import { MessageSquare } from 'lucide-react';
import { z } from 'zod';
import { MobilePageWrapper } from '@/components/ui+/MobilePageWrapper';
import { formatMobileNumber } from '@/utils/formatMobileNumber';
import { TestSmsPreview } from './components/TestSmsPreview';

const SmsSentPage = () => {
  const { mobile } = Route.useSearch();

  return (
    <MobilePageWrapper>
      <div className="flex flex-col items-center pt-8 text-center">
        <div className="flex size-16 items-center justify-center rounded-full bg-primary">
          <MessageSquare className="size-8 text-primary-foreground" />
        </div>
        <h2 className="mt-5 text-3xl font-bold tracking-tight">Check your messages</h2>
        <div className="mt-5 w-full rounded-lg border bg-card px-4 py-3">
          <p className="text-sm text-muted-foreground">
            We've sent a link to {formatMobileNumber(mobile)}.
            <br />
            <br />
            Tap the link in your SMS to verify your mobile number and complete payment.
          </p>
        </div>
      </div>
      <TestSmsPreview mobileNumber={mobile} />
    </MobilePageWrapper>
  );
};

export const Route = createFileRoute('/$companyLocationCode/$siteCode/sms-sent')({
  validateSearch: z.object({
    mobile: z.string(),
  }),
  component: SmsSentPage,
});
